var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from "@madmedical/form";
import Button from "../atoms/Button";
const SubmitButton = (_a) => {
    var { onPress, isDisabled = false, isLoading, label } = _a, rest = __rest(_a, ["onPress", "isDisabled", "isLoading", "label"]);
    const { formState: { isSubmitting, isValid }, } = useFormContext();
    return (_jsx(Button, Object.assign({ isLoading: isSubmitting || isLoading, isLoadingText: `${label}…`, isDisabled: !isValid || isDisabled, variant: "primary", onPress: onPress }, rest, { children: label })));
};
export default SubmitButton;
